import createAction from "../../app/createAction";
import { LOAD_MOBILE_BONUS_INFO_START } from "./mobileBonusConstants";

export const loadMobileBonusInfoAction = (payload) => createAction(LOAD_MOBILE_BONUS_INFO_START, payload);
